/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SecurityScheme } from '../../openapi/v2/models/Oas20SecurityScheme';
import { ChangeSecuritySchemeCommand } from './ChangeSecuritySchemeCommand';
import { Oas20SecurityDefinitions } from '../../openapi/v2/models/Oas20SecurityDefinitions';
import { Oas20Scopes } from '../../openapi/v2/models/Oas20Scopes';

/**
 * @author eric.wittmann@gmail.com
 * @extends ChangeSecuritySchemeCommand
 * @class
 */
export class ChangeSecuritySchemeCommand_20 extends ChangeSecuritySchemeCommand {
    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super(scheme);
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand#getSchemeFromDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {SecurityScheme}
     */
    getSchemeFromDocument(document : Document) : SecurityScheme {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.securityDefinitions)) {
            return null;
        }
        return doc20.securityDefinitions.getSecurityScheme(this._schemeName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand#nullScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} scheme
     */
    nullScheme(scheme : SecurityScheme) {
        super.nullScheme(scheme);
        let scheme20 : Oas20SecurityScheme = <Oas20SecurityScheme>scheme;
        scheme20.tokenUrl = null;
        scheme20.authorizationUrl = null;
        scheme20.flow = null;
        scheme20.scopes = null;
    }
}
ChangeSecuritySchemeCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand_20";
ChangeSecuritySchemeCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




